import { createIcon } from '@chakra-ui/react';

export const MbeAlertOutline = createIcon({
  displayName: 'MbeAlertOutline',
  viewBox: '0 0 64 64',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
        <path d="M0 0h56v56H0z" id="zfmze36sra" />
      </defs>
      <g fill="currentColor" fillRule="evenodd">
        <g transform="translate(4 4)">
          <mask fill="#fff" id="ss3f04b5lb">
            <use xlinkHref="#zfmze36sra" />
          </mask>
          <path
            d="M28 1.412C13.34 1.412 1.412 13.339 1.412 28c0 14.66 11.927 26.588 26.588 26.588 14.66 0 26.588-11.927 26.588-26.588C54.588 13.34 42.661 1.412 28 1.412M28 56C12.56 56 0 43.44 0 28 0 12.56 12.56 0 28 0s28 12.56 28 28c0 15.439-12.56 28-28 28"
            // fill="#E2001A"
            mask="url(#ss3f04b5lb)"
          />
        </g>
        <path
          d="M32 42.472a2.114 2.114 0 0 0-2.112 2.112c0 1.164.948 2.112 2.112 2.112a2.114 2.114 0 0 0 2.111-2.112 2.114 2.114 0 0 0-2.11-2.112m0 6.187a4.08 4.08 0 0 1-4.076-4.075A4.08 4.08 0 0 1 32 40.51a4.08 4.08 0 0 1 4.075 4.075A4.08 4.08 0 0 1 32 48.66M32 37.964a.982.982 0 0 1-.982-.982v-20.66a.982.982 0 0 1 1.964 0v20.66c0 .542-.44.982-.982.982"
          // fill="#E2001A"
        />
      </g>
    </svg>
  ),
});
